export enum SchoolTabsEnum {
  enrollments = 'enrollments',
  explore_courses = 'explore_courses',
}
